import ApiClient from '../../../../services/apiClient/ApiClient'
import type { TagWithBuildings, BuildingTagWithDetails } from '@popety-io/types'

const apiClient = new ApiClient()

export const getBuildingTagsWithBuildingAssociations = async (): Promise<
  TagWithBuildings[]
> => {
  try {
    // Get all building-tag associations
    const tagsResponse = await apiClient.get('/tags/building/all')
    if (tagsResponse.errors) {
      throw new Error(tagsResponse.errors[0].message)
    }

    const BuildingTagWithDetailss: BuildingTagWithDetails[] = tagsResponse.data

    // Group by tag and collect building IDs
    const tagMap = new Map<string, TagWithBuildings>()

    BuildingTagWithDetailss.forEach((relation) => {
      const tagId = relation.tag.id

      if (tagMap.has(tagId)) {
        // Add building ID to existing tag
        const existingTag = tagMap.get(tagId)!
        existingTag.building_ids.push(Number(relation.building_id))
      } else {
        // Create new tag entry
        tagMap.set(tagId, {
          ...relation.tag,
          user: relation.user,
          building_ids: [Number(relation.building_id)],
        })
      }
    })

    return Array.from(tagMap.values())
  } catch {
    throw new Error('Failed to fetch building tags with building associations')
  }
}

// Get tags for a specific building
export const getTagsForBuilding = async (
  buildingId: string
): Promise<BuildingTagWithDetails[]> => {
  try {
    const response = await apiClient.get(`/tags/building/${buildingId}`)
    if (response.errors) {
      throw new Error(response.errors[0].message)
    }
    return response.data as BuildingTagWithDetails[]
  } catch (error: any) {
    console.error(`Failed to get tags for building ${buildingId}:`, error)
    throw new Error(error.message || 'Failed to fetch tags for building')
  }
}
